import React from 'react';
import OrderShipmentListCell from '../../components/admin/OrderShipmentListCell';
import OrderShipmentTracking from '../../components/admin/OrderShipmentTracking';
import { MOCK_DELHIVERY_LIST_ORDER } from '../../helper/shipment_tracking_helper';

export default function ShipmentOrdersPreview() {
  return (
    <div className="main main-app p-3 p-lg-4">
      <h5 className="mb-3">Orders list — Shipment column preview</h5>
      <div className="card card-one border p-3 mb-4" style={{ maxWidth: 280 }}>
        <div className="text-muted small mb-2 fw-semibold">SHIPMENT</div>
        <OrderShipmentListCell order={MOCK_DELHIVERY_LIST_ORDER} />
      </div>
      <h5 className="mb-3">Order detail — Shipment tracking</h5>
      <div style={{ maxWidth: 960 }}>
        <OrderShipmentTracking order={MOCK_DELHIVERY_LIST_ORDER} />
      </div>
    </div>
  );
}
